import { s } from "@kosmod/pancake";

import { defineTool } from "./define";

export const SELECTION_FILTERS = {
  MINI: 'mini',
  TERRAIN: 'terrain',
  SURFACE: 'surface',
  DIE: 'die',
} as const;
export type SELECTION_FILTER = typeof SELECTION_FILTERS[keyof typeof SELECTION_FILTERS];

export const selection = {
  select: defineTool({
    key: 'selection:select',
    state: s.o({
      filter: s.lu(['mini', 'terrain', 'surface', 'die']),
      operation: s.lu(['replace', 'additive', 'subtractive']),
    }),
  }),
  // tile: defineTool({
  //   key: 'selection:tile',
  //   state: s.o({}),
  // }),
  // die: defineTool({
  //   key: 'selection:die',
  //   state: s.o({}),
  // }),
  deselect: defineTool({
    key: 'selection:deselect',
    state: s.o({}),
  })
}